<template>
  <div>
    <div>
      <span class="xbed-sub-title">标签列表</span>
    </div>
    <div style="margin-top:16px; margin-bottom:10px;">标签组：{{groupData.groupId}}_{{groupData.groupName}}</div>
    <br>
    <Form @submit.native.prevent="preventSubmit" inline>
      <FormItem label='标签状态:' :label-width='80'>
        <Select ref="resetCity" v-model="searchParams.isEnabled" filterable>
          <Option value="">全部</Option>
          <Option v-for="(item, index) in allstatus" :value="item.id" :key="index">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem :label-width="10">
        <Button type="primary" @click="getTaglistFn">查询</Button>
      </FormItem>
      <FormItem :label-width="10">
        <Button type="primary" @click="openAddTagModalFn">新增标签</Button>
      </FormItem>
    </Form>

    <div style="margin: 10px;overflow: hidden">
      <Page show-sizer show-total :page-size="pageParams.pageSize" :current="pageParams.pageNum" :total="pageParams.total" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
    </div>
    <Table stripe :columns="columnsList" :data='taglist' :loading='isloading'></Table>

    <!-- 新增编辑标签 -->
    <Modal v-model="modalConfig.display" :title="modalConfig.title" @on-ok="submitBtn">
      <Form :label-width="80" :model="modalConfig.data">
        <FormItem label="ID:" v-if="modalConfig.data.id">
          <span>{{modalConfig.data.id}}</span>
        </FormItem>
        <FormItem label="名称:" required>
          <Input v-model="modalConfig.data.name" placeholder="" style="width:300px;"></Input>
        </FormItem>
        <FormItem label="图标:" prop="iconUrl">
          <input type="hidden" v-model="modalConfig.data.iconUrl">
          <Upload ref="upload"
            :on-success="handleSuccess"
            :format="['jpg','jpeg','png']"
            :max-size="4096"
            :data="uploadData"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :before-upload="handleBeforeUpload"
            action="//upload.qiniup.com">
            <Button>选择文件</Button>
          </Upload>
        </FormItem>
        <FormItem label="状态" required>
          <Select v-model="modalConfig.data.isEnabled"  style="width:300px;">
            <Option :value="0">停用</Option>
            <Option :value="1">启用</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import API from "@/api";
import Utils from "../../utils";
export default {
  data(){
    return{
      searchParams: {
        isEnabled: "",
      },
      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      modalLoading:false,
      modalConfig: {
        title: '新增标签',
        display: false,
        data: {
          id: '',
          name: '',
          iconUrl: '',
          isEnabled: 1
        },
        defaultData: {
          id: '',
          name: '',
          iconUrl: '',
          isEnabled: 1
        },
      },
      uploadData: {
        'token': '',
        'x:fileDirId:': -1,
        'x:isPrivate': 1,
        'x:remark': '' 
      },
      allstatus: [
        {id:0,name:'停用'},
        {id:1,name:'启用'}
      ],
      taglist: [],
      isloading: false,
      columnsList:[
        {
          title:'标签ID',
          key:'id',
          align:'center',
          width:200
        },
        {
          title:'标签名称',
          key:'name',
          align:'center',
          width:300
        },
        {
          title:'图标',
          key:'icon',
          align:'center',
          width:120,
          render: (h, params) => {
            let type = params.row.icon?'查看':'无'
            return h('span', {
              props: {
                type: "primary",
                size: "small"
              },
              style: {
                marginRight: "10px",
                color: params.row.icon?"#0000ff":"#000000"
              },
              on: {
                click: () => {
                  if(params.row.icon) {
                    window.open(params.row.icon)
                  }
                }
              }
            }, type)
          }
        },
        {
          title:'状态',
          key:'isEnabled',
          align:'center',
          width:120,
          render: (h, params) => {
            let state = ['停用', '启用'][params.row.isEnabled]
            return h('span', {}, state)
          }
        },
        {
          title:'关联数',
          key:'relateNum',
          align:'center',
          width:140
        },
        {
          title:'操作',
          align:'center',
          width:300,
          render: (h, params) => {
            return h('div',[
              h('Button',{
                props: {
                  type: "primary",
                  size: "small"
                },
                style: {
                  marginRight: "10px"
                },
                on: {
                  click: () => {
                    this.openEditTagModalFn(params.row)
                  }
                }
              },'编辑'),
              h('Button',{
                props: {
                  type: "primary",
                  size: "small"
                },
                on: {
                  click: () => {
                    this.forwardToTagUserlistPageFn(params.row.id)
                  }
                }
              },'用户明细'),
            ])
          }
        }
      ]
    }
  },

  created () {
    let groupId = Utils.getUrlParameterByName( 'id' )
    let groupName = Utils.getUrlParameterByName( 'name' )
    let tagType = Utils.getUrlParameterByName( 'tagType' )

    this.groupData = {
      groupId: groupId,
      groupName: groupName,
      tagType: tagType
    }
    this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.userId = Utils.findFromLocalStorage( "vue-userid" );
    this.env = Utils.findFromLocalStorage( "env", "dev" );

    // 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
    this.protHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), 
      'Authorization': Utils.findFromLocalStorage("Author-token"),
      // 'secret': '58dbac0cb9a1db115a473199f8d312e6', // 本地请求 IP 域名才需要传 secret
    }
    this.getTaglistFn()
    this.getUploadToken()
  },

  methods: {
    async getTaglistFn(){
      let params = {
        groupId: this.groupData.groupId,
        tagType: this.groupData.tagType,
        isEnabled: this.searchParams.isEnabled,
        pageNum: this.pageParams.pageNum,
        pageSize: this.pageParams.pageSize,
      }
      try {
        let resp = (await API.omsAPI[this.env].clientServer.getTagList(params, this.protHeaders)).data;
        this.isloading = false
        if (resp.retCode) {
          this.$Notice.error({
            title: '获取标签列表数据异常',
            desc: resp.msg
          })
          return
        }
        this.taglist = resp.list
        this.pageParams.total = resp.total
      } catch(e) {
        this.isloading = false
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    },

    changePageSize(pageSize) {
      this.pageParams.pageNum = 1;
			this.pageParams.pageSize = pageSize;
			this.getTaglistFn();
    },

    changePage(page) {
      this.pageParams.pageNum = page;
			this.getTaglistFn();
    },

    openAddTagModalFn() {
      if (!Utils.hasPermission('tagAdd')) {
        this.$Notice.error({
          title: "无权限操作"
        });
        return
      }
      this.modalConfig.data = Object.assign({}, this.modalConfig.defaultData)
      this.modalConfig.title = '新增标签';
      this.modalConfig.display = true;
    },

    openEditTagModalFn(obj) {
      if (!Utils.hasPermission('tagEdit')) {
        this.$Notice.error({
          title: "无权限操作"
        });
        return
      }
      this.modalConfig.data = Object.assign({}, this.modalConfig.defaultData, obj)
      this.modalConfig.title = '编辑标签';
      this.modalConfig.display = true
    },

    submitBtn() {
      if (!this.modalConfig.data.name.trim()) {
        this.$Notice.error({
          title: '标签名称不能为空',
        })
        return
      }
      let params = {
        groupId: this.groupData.groupId,
        name: this.modalConfig.data.name,
        icon: this.modalConfig.data.iconUrl? this.modalConfig.data.iconUrl : '',
        isEnabled: this.modalConfig.data.isEnabled
      }
      if (this.modalConfig.data.id) {
        params.id = this.modalConfig.data.id
        this.editTagFn(params)
      } else {
        this.addNewTagFn(params)
      }
    },

    async addNewTagFn(params) {
      try {
        let resp = await API.omsAPI[this.env].clientServer.addNewTag(params, this.protHeaders);
        this.isloading = false
        if (resp.data.retCode) {
          this.$Notice.error({
            title: '新增标签数据异常',
            desc: resp.data.msg
          })
          return
        }
        
        this.$Notice.success({
          title: '新增标签成功',
        })
        this.pageParams.pageNum = 1
        this.getTaglistFn()
      } catch(err) {
        this.isloading = false
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    },

    async editTagFn(params) {
      try {
        let resp = await API.omsAPI[this.env].clientServer.editTag(params, this.protHeaders);
        this.isloading = false
        if (resp.retCode) {
          this.$Notice.error({
            title: '编辑标签数据异常',
            desc: resp.msg
          })
          return
        }
        
        this.$Notice.success({
          title: '标签编辑成功',
        })
        this.pageParams.pageNum = 1
        this.getTaglistFn()
      } catch(err) {
        this.isloading = false
        this.$Notice.error({
          title: '服务器异常，请稍后再试'
        })
      }
    },

    forwardToTagUserlistPageFn(tagId) {
      if (!Utils.hasPermission('tagDetailList')) {
        this.$Notice.error({
          title: "无权限操作"
        });
        return
      }
      let _url = this.$router ? '#/app/marketing/tagDetailList' : '#/Market/Market/tagDetailList'
      _url = `${_url}?tagType=${this.groupData.tagType}&groupId=${this.groupData.groupId}&tagId=${tagId}`
      window.open(_url)
    },

    async getUploadToken() {
      this.uploadData.token = (await API.omsAPI[this.env].common.getUploadToken(true, this.token)).data
    },

    handleSuccess (res) {
      this.modalConfig.data.iconUrl = res.materialBase.url;
    },

    handleFormatError() {
      this.$Notice.warning({
        title: '格式不支持',
      });
    },

    handleMaxSize() {
      this.$Notice.warning({
        title: '请上传小于4M的图片',
      });
    },

    handleBeforeUpload() {
      this.$refs.upload.clearFiles()
      return true;
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/marketing/tagList.vue